// Remove extra whitespace generated by ReactDOMServer
export const trimWhitespace = (rawHtml: string): string =>
  rawHtml.replace(/(\r\n|\n|\r|\t)/gm, '');
